import { makeGqlRequest } from './helpers'
import {
  getJobs,
  getUsers,
  getJobApplications,
  getJobListings
} from './queries'
import {
  updateJobListingExpiry as updateJobListingExpiryMutation,
  createPushTemplate as createPushTemplateMutation
} from './mutations'
import {
  FetchJobsPayload,
  FetchUsersPayload,
  Job,
  FetchJobApplicationPayload,
  FetchJobListingsPayload,
  JobListing
} from './types'

export async function fetchUsers(payload: FetchUsersPayload, jwt: string) {
  const { users } = await makeGqlRequest(getUsers, payload, jwt)
  return users
}

export async function fetchJobs(
  payload: FetchJobsPayload,
  jwt: string
): Promise<Job[]> {
  const { jobs } = await makeGqlRequest(getJobs, payload, jwt)
  return jobs.jobs
}

export async function fetchJobListings(
  payload: FetchJobListingsPayload,
  jwt: string
): Promise<{ jobListings: JobListing[]; count: number }> {
  const { jobListings } = await makeGqlRequest(getJobListings, payload, jwt)
  return jobListings
}

export async function fetchJobApplications(
  payload: FetchJobApplicationPayload,
  jwt: string
) {
  const { jobApplications } = await makeGqlRequest(
    getJobApplications,
    payload,
    jwt
  )
  return jobApplications
}

export async function updateJobListingExpiry(
  id: string,
  expiresAt: Date,
  jwt: string
): Promise<void> {
  await makeGqlRequest(updateJobListingExpiryMutation, { id, expiresAt }, jwt)
}

export async function createPushTemplate(
  payload: {
    title: string
    content: string
    notes?: string | null
    link?: string | null
  },
  jwt: string
) {
  const { createPushTemplate } = await makeGqlRequest(
    createPushTemplateMutation,
    payload,
    jwt
  )
  return createPushTemplate
}
